import { render, staticRenderFns } from "./SmallMessagesTable.vue?vue&type=template&id=9cba759a&scoped=true"
import script from "./SmallMessagesTable.vue?vue&type=script&lang=js"
export * from "./SmallMessagesTable.vue?vue&type=script&lang=js"
import style0 from "./SmallMessagesTable.vue?vue&type=style&index=0&id=9cba759a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cba759a",
  null
  
)

export default component.exports